var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoProfileView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "80px",
    viewBox: "0 0 108 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNoProfileView") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.608247,208.731959 C196.629084,208.731959 204.752577,200.79309 204.752577,191 C204.752577,181.20691 196.629084,173.268041 186.608247,173.268041 C176.587411,173.268041 168.463918,181.20691 168.463918,191 C168.463918,200.79309 176.587411,208.731959 186.608247,208.731959 Z M240.934065,190.320731 C233.278039,166.800792 211.611112,151 187.0205,151 C162.429887,151 140.763171,166.800792 133.107146,190.320731 C132.964285,190.761355 132.964285,191.238645 133.107146,191.679269 C140.763171,215.199208 162.430098,231 187.020711,231 C211.611323,231 233.278039,215.199208 240.934276,191.679269 C241.076926,191.238645 241.076926,190.761355 240.934065,190.320731 Z M186.608247,221.927835 C169.326883,221.927835 155.268041,208.053771 155.268041,191 C155.268041,173.946229 169.327093,160.072165 186.608247,160.072165 C203.889402,160.072165 217.948454,173.946229 217.948454,191 C217.948454,208.053771 203.889611,221.927835 186.608247,221.927835 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Views-Non-display-Copy",
    transform: "translate(-133.000000, -151.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icNoProfileView",
    fillOpacity: 0.6,
    fill: "#666666",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoProfileView);
export default __webpack_public_path__ + "static/media/icNoProfileView.504b5e496a41ae7c8d8d08d65c49124b.svg";
export { ForwardRef as ReactComponent };